import React, { Component } from 'react';

export default class floDeskForm extends Component {
  constructor(props) {
      super(props);
  }

  componentDidMount = () =>{
    if(!this.props.segment){
      (function(w, d, t, h, s, n) {
        w.FlodeskObject = n;
        var fn = function() {
          (w[n].q = w[n].q || []).push(arguments);
        };
        w[n] = w[n] || fn;
        var f = d.getElementsByTagName(t)[0];
        var v = '?v=' + Math.floor(new Date().getTime() / (120 * 1000)) * 60;
        var sm = d.createElement(t);
        sm.async = true;
        sm.type = 'module';
        sm.src = h + s + '.mjs' + v;
        f.parentNode.insertBefore(sm, f);
        var sn = d.createElement(t);
        sn.async = true;
        sn.noModule = true;
        sn.src = h + s + '.js' + v;
        f.parentNode.insertBefore(sn, f);
      })(window, document, 'script', 'https://assets.flodesk.com', '/universal', 'fd');

      window.fd('form', {
        formId: '622ce9669b7136a9e313dfa7',
        containerEl: '#fd-form-622ce9669b7136a9e313dfa7'
      });
    }

    if(this.props.segment == "5 Brainfucks"){
      (function(w, d, t, h, s, n) {
        w.FlodeskObject = n;
        var fn = function() {
          (w[n].q = w[n].q || []).push(arguments);
        };
        w[n] = w[n] || fn;
        var f = d.getElementsByTagName(t)[0];
        var v = '?v=' + Math.floor(new Date().getTime() / (120 * 1000)) * 60;
        var sm = d.createElement(t);
        sm.async = true;
        sm.type = 'module';
        sm.src = h + s + '.mjs' + v;
        f.parentNode.insertBefore(sm, f);
        var sn = d.createElement(t);
        sn.async = true;
        sn.noModule = true;
        sn.src = h + s + '.js' + v;
        f.parentNode.insertBefore(sn, f);
      })(window, document, 'script', 'https://assets.flodesk.com', '/universal', 'fd');

      window.fd('form', {
        formId: '622cf0cf78ab99224ea6e8b5',
        containerEl: '#fd-form-622cf0cf78ab99224ea6e8b5'
      });
    }

    if(this.props.segment == "7 Day Challenge"){
      (function(w, d, t, h, s, n) {
        w.FlodeskObject = n;
        var fn = function() {
          (w[n].q = w[n].q || []).push(arguments);
        };
        w[n] = w[n] || fn;
        var f = d.getElementsByTagName(t)[0];
        var v = '?v=' + Math.floor(new Date().getTime() / (120 * 1000)) * 60;
        var sm = d.createElement(t);
        sm.async = true;
        sm.type = 'module';
        sm.src = h + s + '.mjs' + v;
        f.parentNode.insertBefore(sm, f);
        var sn = d.createElement(t);
        sn.async = true;
        sn.noModule = true;
        sn.src = h + s + '.js' + v;
        f.parentNode.insertBefore(sn, f);
      })(window, document, 'script', 'https://assets.flodesk.com', '/universal', 'fd');

      window.fd('form', {
        formId: '622cf4ba7e7ec064e82a190c',
        containerEl: '#fd-form-622cf4ba7e7ec064e82a190c'
      });
    }

    if(this.props.segment == "Notify Me"){
      (function(w, d, t, h, s, n) {
        w.FlodeskObject = n;
        var fn = function() {
          (w[n].q = w[n].q || []).push(arguments);
        };
        w[n] = w[n] || fn;
        var f = d.getElementsByTagName(t)[0];
        var v = '?v=' + Math.floor(new Date().getTime() / (120 * 1000)) * 60;
        var sm = d.createElement(t);
        sm.async = true;
        sm.type = 'module';
        sm.src = h + s + '.mjs' + v;
        f.parentNode.insertBefore(sm, f);
        var sn = d.createElement(t);
        sn.async = true;
        sn.noModule = true;
        sn.src = h + s + '.js' + v;
        f.parentNode.insertBefore(sn, f);
      })(window, document, 'script', 'https://assets.flodesk.com', '/universal', 'fd');

      window.fd('form', {
        formId: '622e3e017e7ec064e82a197d',
        containerEl: '#fd-form-622e3e017e7ec064e82a197d'
      });
    }

    if(this.props.segment == "Yearly Audit"){
      (function(w, d, t, h, s, n) {
        w.FlodeskObject = n;
        var fn = function() {
          (w[n].q = w[n].q || []).push(arguments);
        };
        w[n] = w[n] || fn;
        var f = d.getElementsByTagName(t)[0];
        var v = '?v=' + Math.floor(new Date().getTime() / (120 * 1000)) * 60;
        var sm = d.createElement(t);
        sm.async = true;
        sm.type = 'module';
        sm.src = h + s + '.mjs' + v;
        f.parentNode.insertBefore(sm, f);
        var sn = d.createElement(t);
        sn.async = true;
        sn.noModule = true;
        sn.src = h + s + '.js' + v;
        f.parentNode.insertBefore(sn, f);
      })(window, document, 'script', 'https://assets.flodesk.com', '/universal', 'fd');

      window.fd('form', {
       formId: '63aba0fe1488000c28b9bc97',
       containerEl: '#fd-form-63aba0fe1488000c28b9bc97'
      });
    }

    if(this.props.segment == "Goal Setting"){
      (function(w, d, t, h, s, n) {
        w.FlodeskObject = n;
        var fn = function() {
          (w[n].q = w[n].q || []).push(arguments);
        };
        w[n] = w[n] || fn;
        var f = d.getElementsByTagName(t)[0];
        var v = '?v=' + Math.floor(new Date().getTime() / (120 * 1000)) * 60;
        var sm = d.createElement(t);
        sm.async = true;
        sm.type = 'module';
        sm.src = h + s + '.mjs' + v;
        f.parentNode.insertBefore(sm, f);
        var sn = d.createElement(t);
        sn.async = true;
        sn.noModule = true;
        sn.src = h + s + '.js' + v;
        f.parentNode.insertBefore(sn, f);
      })(window, document, 'script', 'https://assets.flodesk.com', '/universal', 'fd');

      window.fd('form', {
       formId: '63b5b318d4043cac46b33bf0',
       containerEl: '#fd-form-63b5b318d4043cac46b33bf0'
      });
    }

  }
  render() {
    return (
      <div className="full-width primary-background">
        {!this.props.segment && <div id="fd-form-622ce9669b7136a9e313dfa7"></div>}
        {this.props.segment == "5 Brainfucks" && <div id="fd-form-622cf0cf78ab99224ea6e8b5"></div>}
        {this.props.segment == "7 Day Challenge" && <div id="fd-form-622cf4ba7e7ec064e82a190c"></div>}
        {this.props.segment == "Notify Me" && <div id="fd-form-622e3e017e7ec064e82a197d"></div>}
        {this.props.segment == "Yearly Audit" && <div id="fd-form-63aba0fe1488000c28b9bc97"></div>}
        {this.props.segment == "Goal Setting" && <div id="fd-form-63b5b318d4043cac46b33bf0"></div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/flodeskForm/index.js